import { connect } from 'react-redux';
import { compose } from 'redux';
import PanelShadows from '../../components/handoff/PanelShadows';
import onlyIf from '../../hocs/onlyIf';
import { getSelectedElement } from '../../selectors/handoff';
import * as handoff from '../../utils/handoff/element';
function mapStateToProps(state) {
    var element = getSelectedElement(state);
    return {
        shadows: handoff.getElementShadows(element),
        innerShadows: handoff.getElementInnerShadows(element),
    };
}
export default compose(connect(mapStateToProps), onlyIf(function (props) { return props.shadows.length || props.innerShadows.length; }))(PanelShadows);
